import { createEnumMap } from 'Commons/helpers/utils/Formatter';
import enums from './Enums';

const FORM_COMPONENTS = createEnumMap(enums.formComponents);
const VARIANT = createEnumMap(enums.variant);
const INPUT_TYPE = createEnumMap(enums.inputType);

export { FORM_COMPONENTS, VARIANT, INPUT_TYPE };
